//#region IMPORT
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
/** Services Import */
import Global from '../../Services/Common/Global';
import Commons from '../../Services/Common/Common';
/** Components Import */
import { MyPage, MyPage_Mobile } from './index';
import { Loading, Snackbar, Dialog, Button } from '../../Components/MUIs';
import { convertFieldResponseIntoMuiTextFieldProps } from '@mui/x-date-pickers/internals';
import { useOutletContext } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../Reducer/SnackbarReducer';

//#endregion

function MyPageFunction() {
  //#region 변수
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { updateProfile } = useOutletContext();
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    type: Commons.TypeInfo().toLowerCase(),
  });
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);
  const [codeList, setCodeList] = useState([]);
  const [modalToggle, setModalToggle] = useState(); // PC 보건카드 모달
  const [modalToggle2, setModalToggle2] = useState(); // PC 서명 보기 모달
  const [modalToggle3, setModalToggle3] = useState(); // PC 서명 등록 모달
  const [modalToggle4, setModalToggle4] = useState(); // 회원탈퇴 모달
  const [modalToggle5, setModalToggle5] = useState(); // 직인 모달
  const [modalToggle6, setModalToggle6] = useState(); // 직인 예시 모달
  const [mobileModalToggle, setMobileModalToggle] = useState(); // 모바일 비밀번호 확인 모달
  const [mobileModalToggle2, setMobileModalToggle2] = useState(); // 모바일 비밀번호 변경 모달
  const [imageDialog, setImageDialog] = useState(); // 모바일 보건카드 모달
  const [signDialog, setSignDialog] = useState(); // 모바일 서명 보기 모달
  const [signCreateDialog, setSignCreateDialog] = useState(); // 모바일 서명 등록 모달
  const [workSignature, setWorkSignature] = useState(''); // 전자서명 string
  const [viewState, setViewState] = useState(0);
  const [idDelete, setIdDelete] = useState(false);
  const [careerPeriodList, setCareerPeriodList] = useState([]); //경력기간 코드
  const [nationList, setNationList] = useState([]); //국적 코드
  const [bloodList, setBloodList] = useState([]); //혈액형 코드
  const [inputs, setInputs] = useState({
    currentPassword: '',
    password: '',
    passwordConfirm: '',
  });
  const [confirm, setConfirm] = useState(false);
  const [certificationInputs, setCertificationInputs] = useState({
    passwoard: '',
  });

  const [inputs2, setInputs2] = useState({
    id: '',
    name: '',
    tel: '',
    emtel: '',
    birth: '',
    careerYn: '',
    careerPeriod: '',
    blood: '',
    address1: '',
    address2: '',
    post: '',
    nation: '',
    visa: '',
    photo: '',
    email: '',
    healthImage: '',
    sign: '',
    journeyman: '',
  });
  const [imageFile, setImageFile] = React.useState({
    //이미지 설정
    profileFiles: '', //파일 String(프로필)
    profileImage: '', // 파일 정보(프로필)
    profileFileName: '', //파일이름(프로필)
    healthFiles: '', //파일 String(보건카드)
    healthImage: '', // 파일 정보(보건카드)
    healthFileName: '', //파일이름(보건카드)
    signFiles: '', //파일 String(서명)
    signImage: '', // 파일 정보(서명)
    signFileName: '', //파일이름(서명)
    journeyFiles: '', //파일 String(직인)
    journeyImage: '', // 파일 정보(직인)
    journeyFileName: '', //파일이름(직인)
  });
  const [capsLockFlag, setCapsLockFlag] = useState(false);
  //#endregion

  useEffect(() => {
    Init();
  }, []);

  const Init = async () => {
    setLoading(true);

    try {
      SearchCode();
    } catch (e) {
      console.log('Error: ', e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: Commons.TypeError().toLowerCase(),
      });
    } finally {
      setLoading(false);
    }
  };

  //#region 조회
  // 경력 코드 조회
  const SearchCode = async () => {
    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_GetCode',
          },
        ]
      ).then((result) => {
        let data = result.data;
        let data1 = [];
        let data2 = [];

        if (data.length == 0) {
          setCareerPeriodList([]);
        } else if (data[0]?.type === Commons.TypeError()) {
          //Get할 땐 에러인 경우 인덱스 0 에 {type:"Error"} 로 반환되고, 에러가 아닐 경우엔 정상적인 데이터 반환
          throw new Error(data[0].message);
        } else {
          setCodeList(data);
          data = data.sort((a, b) => a.ref1 - b.ref1);
          data1 = data
            .filter((f) => f.groupCd === 'NATION')
            .map((item) => ({
              name: item.codeNm,
              value: item.code,
            }));
          data2 = data
            .filter((f) => f.groupCd === 'BloodType')
            .map((item) => ({
              name: item.codeNm,
              value: item.code,
            }));
          data = data
            .filter((f) => f.groupCd === 'CAREER_PERIOD')
            .map((item) => ({
              name: item.codeNm,
              value: item.code,
            }));
          // data.unshift({
          //   name: "없음",
          //   value: "None",
          // });
          setCareerPeriodList(data);
          setNationList(data1);
          setBloodList(data2);
        }
      });
    } catch (e) {
      console.log(e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: Commons.TypeError().toLowerCase(),
      });
    } finally {
    }
  };

  // 비밀번호 확인
  const SearchLogic1 = async () => {
    setLoading(true);

    try {
      if (!certificationInputs.passwoard) {
        throw new Error(
          lanInfo.length > 0
            ? lanInfo.filter((f) => f.LAN_ID === 'PleaseEnterYourPassword')[0]
                .LAN_NM // 비밀번호를 입력하세요.
            : ''
        );
      }

      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_GetLogin',
            value1: Commons.EncryptAES(userInfo.userid), // ID
            value2: Commons.EncryptAES(certificationInputs.passwoard), // PW
          },
        ]
      ).then((result) => {
        let data = result.data;

        if (data.length > 0 && data[0].ID === userInfo.userid) {
          SearchLogic2(data[0].PHOTO, 'profile');
          setCertificationInputs({
            ...certificationInputs,
            passwoard: '',
          });
          setInputs2({
            ...inputs,
            id: data[0].ID,
            name: data[0].NAME,
            tel: data[0].TEL,
            emtel: data[0].EMTEL,
            birth: data[0].BIRTH,
            careerYn: data[0].CAREER_YN,
            careerPeriod: data[0].CAREER_PERIOD,
            blood: data[0].BLOOD,
            address1: data[0].ADDRESS1,
            address2: data[0].ADDRESS2,
            post: data[0].POST,
            nation: data[0].NATION,
            visa: data[0].VISA,
            photo: data[0].PHOTO,
            email: data[0].EMAIL,
            healthImage: data[0].HEALTH_IMAGE,
            sign: data[0].SIGN,
            journeyman: data[0].JOURNEYMAN,
          });

          if (Commons.IsMobile()) {
            setViewState(1);
            setMobileModalToggle(false);
          } else {
            setConfirm(true);
          }
        } else {
          throw new Error(
            lanInfo.length > 0
              ? lanInfo.filter((f) => f.LAN_ID === 'ThePasswordIsDifferent')[0]
                  .LAN_NM // 비밀번호가 다릅니다.
              : ''
          );
        }
      });
    } catch (e) {
      console.log('Error: ', e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: Commons.TypeError().toLowerCase(),
      });
    } finally {
      setLoading(false);
    }
  };

  //사진 가져오기
  const SearchLogic2 = async (_item, _type) => {
    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.ftpResponse,
        {
          value1: Commons.EncryptAES(_item),
        }
      ).then((result) => {
        let data = result.data;

        if (data !== Commons.TypeError()) {
          if (_type === 'profile') {
            setImageFile({
              ...imageFile,
              profileFiles: `data:image/png;base64,${data}`,
              profileImage: {
                name: _item.split('/')[_item.split('/').length - 1],
              },
            });
          } else if (_type === 'health') {
            setImageFile({
              ...imageFile,
              healthFiles: `data:image/png;base64,${data}`,
              healthImage: {
                name: _item.split('/')[_item.split('/').length - 1],
              },
            });
          } else if (_type === 'sign') {
            setImageFile({
              ...imageFile,
              signFiles: `data:image/png;base64,${data}`,
              signImage: {
                name: _item.split('/')[_item.split('/').length - 1],
              },
            });
          } else if (_type === 'journeyman') {
            setImageFile({
              ...imageFile,
              journeyFiles: `data:image/png;base64,${data}`,
              journeyImage: {
                name: _item.split('/')[_item.split('/').length - 1],
              },
            });
          }
        }
      });
    } catch (e) {
      console.log(e);
    } finally {
    }
  };
  //#endregion

  //#region 저장
  // 개인정보 수정
  const SaveLogic1 = async () => {
    setLoading(true);
    let formList = new FormData();
    let emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    try {
      if (!inputs2.name) {
        setSnackbar({
          ...snackbar,
          open: true,
          message:
            lanInfo.length == 0
              ? ''
              : lanInfo.find(
                  (f) => f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'EnterName'
                ).LAN_NM,
          type: Commons.TypeWarning().toLowerCase(), // 이름을 입력하세요.
        });
        return false;
      } else if (!inputs2.tel) {
        setSnackbar({
          ...snackbar,
          open: true,
          message:
            lanInfo.length == 0
              ? ''
              : lanInfo.find(
                  (f) =>
                    f.LAN_TYPE !== 'MENU' &&
                    f.LAN_ID === 'PleaseEnterYourPhoneNumber'
                ).LAN_NM,
          type: Commons.TypeWarning().toLowerCase(), // 전화번호를 입력하세요.
        });
        return false;
      } else if (!inputs2.email) {
        setSnackbar({
          ...snackbar,
          open: true,
          message:
            lanInfo.length == 0
              ? ''
              : lanInfo.find(
                  (f) => f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'EnterEmail'
                ).LAN_NM,
          type: Commons.TypeWarning().toLowerCase(), // 이메일을 입력하세요.
        });
        return false;
      } else if (
        inputs2.careerYn === 'Y' &&
        (!inputs2.careerPeriod || inputs2.careerPeriod === '0')
      ) {
        setSnackbar({
          ...snackbar,
          open: true,
          message:
            lanInfo.length == 0
              ? ''
              : lanInfo.find(
                  (f) => f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'EnterCareer'
                ).LAN_NM,
          type: Commons.TypeWarning().toLowerCase(), // 경력기간을 입력하세요.
        });
        return false;
      } else if (!emailRegex.test(inputs2.email)) {
        setSnackbar({
          ...snackbar,
          open: true,
          message: 'E-Mail을 확인 하세요.',
          type: Commons.TypeWarning().toLowerCase(),
        });
        return false;
      }

      if (imageFile.profileImage.size) {
        formList.append('value1', Commons.EncryptAES(userInfo.userid));
        formList.append(
          'value2',
          Commons.EncryptAES(`User_Info/${inputs2.id}/Profile`)
        );
        formList.append('value3', imageFile.profileImage);

        await Commons.Axios(
          'file',
          Global.base.useUrl + Global.urls.Execute.ftpRequest,
          null,
          formList
        ).then((result) => {
          let data = result.data;
        });
      }

      await Commons.Axios(
        'post1',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_MyPage_U2',
            value1: Commons.EncryptAES(inputs2.id) || '',
            value2: Commons.EncryptAES(inputs2.name) || '',
            value3: Commons.EncryptAES(inputs2.tel) || '',
            value4: Commons.EncryptAES(inputs2.emtel) || '',
            value5: Commons.EncryptAES(inputs2.careerYn) || '',
            value6: Commons.EncryptAES(inputs2.careerPeriod) || '',
            value7: Commons.EncryptAES(inputs2.address1) || '',
            value8: Commons.EncryptAES(inputs2.address2) || '',
            value9: Commons.EncryptAES(inputs2.post) || '',
            value10: Commons.EncryptAES(inputs2.visa) || '',
            value11:
              Commons.EncryptAES(
                imageFile.profileImage
                  ? `User_Info/${inputs2.id}/Profile/${imageFile.profileImage.name}`
                  : ''
              ) || '',
            value12: Commons.EncryptAES(inputs2.email) || '',
            value13: Commons.EncryptAES(inputs2.blood) || '',
            value14: Commons.EncryptAES(inputs2.nation) || '',
          },
        ]
      ).then((result) => {
        let data = result.data;

        if (data.length > 0) {
          if (data[0].type === 'Ok') {
            // userInfo photo 업데이트
            // IndexedDb.UpdateTable('UserInfo', Commons.EncryptAES(inputs2.id), {
            //   ...userData,
            //   photo: imageFile.profileImage
            //     ? `User_Info/${inputs2.id}/Profile/${imageFile.profileImage.name}`
            //     : '',
            //   userid: Commons.EncryptAES(inputs2.id),
            // });

            // 업데이트 후 상위 컴포넌트에 알림
            updateProfile(
              imageFile.profileImage
                ? `User_Info/${inputs2.id}/Profile/${imageFile.profileImage.name}`
                : ''
            );
            setSnackbar({
              ...snackbar,
              open: true,
              message:
                lanInfo.length > 0
                  ? lanInfo.filter((f) => f.LAN_ID === 'ItHasBeenSaved')[0]
                      .LAN_NM
                  : '',
              type: Commons.TypeSuccess().toLowerCase(),
            });
            if (Commons.IsMobile()) {
              window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth',
              });
            }
          } else {
            throw new Error(data[0].message ? data[0].message : '');
          }
        }
      });
    } catch (e) {
      console.log('Error: ', e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: Commons.TypeError().toLowerCase(),
      });
    } finally {
      setLoading(false);
    }
  };

  // 비밀번호 변경
  const SaveLogic2 = async () => {
    setLoading(true);
    let passwordRegex =
      /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;

    try {
      if (!inputs.currentPassword) {
        setSnackbar({
          ...snackbar,
          open: true,
          message:
            lanInfo.length > 0
              ? lanInfo.filter(
                  (f) => f.LAN_ID === 'PleaseEnterYourCurrentPassword'
                )[0].LAN_NM
              : '',
          type: Commons.TypeWarning().toLowerCase(), // 현재 비밀번호를 입력하세요.
        });
        return false;
      } else if (!inputs.password) {
        setSnackbar({
          ...snackbar,
          open: true,
          message:
            lanInfo.length > 0
              ? lanInfo.filter((f) => f.LAN_ID === 'PleaseEnterYourPassword')[0]
                  .LAN_NM
              : '',
          type: Commons.TypeWarning().toLowerCase(), // 비밀번호를 입력하세요.
        });
        return false;
      } else if (!inputs.passwordConfirm) {
        setSnackbar({
          ...snackbar,
          open: true,
          message:
            lanInfo.length > 0
              ? lanInfo.filter(
                  (f) => f.LAN_ID === 'PleaseEnterYourPasswordConfirm'
                )[0].LAN_NM
              : '',
          type: Commons.TypeWarning().toLowerCase(), // 비밀번호 확인을 입력하세요.
        });
        return false;
      } else if (inputs.password !== inputs.passwordConfirm) {
        setSnackbar({
          ...snackbar,
          open: true,
          message:
            lanInfo.length > 0
              ? lanInfo.filter((f) => f.LAN_ID === 'ThePasswordIsDifferent')[0]
                  .LAN_NM
              : '',
          type: Commons.TypeWarning().toLowerCase(), // 비밀번호가 다릅니다.
        });
        return false;
      } else if (!passwordRegex.test(inputs.password)) {
        setSnackbar({
          ...snackbar,
          open: true,
          message: '비밀번호를 확인 하세요.',
          type: Commons.TypeWarning().toLowerCase(),
        });
        return false;
      }

      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Account.ChangePassword,
        {
          UserId: userInfo.userid,
          CurrentPassword: Commons.EncryptAES(inputs.currentPassword),
          NewPassword: Commons.EncryptAES(inputs.passwordConfirm),
        }
      ).then((result) => {
        let data = result.data;

        if (data && data.type === 'Ok') {
          dispatch(
            showSnackbar({
              message:
                lanInfo.length > 0
                  ? lanInfo.filter((f) => f.lanId === 'ItHasBeenChanged')[0]
                      ?.lanNm
                  : '변경되었습니다.',
              type: 'success',
            })
          );
        } else {
          throw new Error(data?.message || '변경에 실패했습니다.');
        }
      });
    } catch (e) {
      console.log('Error: ', e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: Commons.TypeError().toLowerCase(),
      });
    } finally {
      setLoading(false);
    }
  };

  // 보건카드 저장
  const SaveLogic3 = async () => {
    setLoading(true);
    let formList = new FormData();

    try {
      if (!imageFile.healthImage) {
        setSnackbar({
          ...snackbar,
          open: true,
          message:
            lanInfo.length == 0
              ? ''
              : lanInfo.find(
                  (f) => f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'NoImages'
                ).LAN_NM,
          type: Commons.TypeWarning().toLowerCase(), // 사진이 없습니다.
        });
        return false;
      }

      if (imageFile.healthImage.size) {
        formList.append('value1', Commons.EncryptAES(userInfo.userid));
        formList.append(
          'value2',
          Commons.EncryptAES(`User_Info/${inputs2.id}/Health`)
        );
        formList.append('value3', imageFile.healthImage);

        await Commons.Axios(
          'file',
          Global.base.useUrl + Global.urls.Execute.ftpRequest,
          null,
          formList
        ).then((result) => {
          let data = result.data;
        });
      }

      await Commons.Axios(
        'post1',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_MyPage_U3',
            value1: Commons.EncryptAES(inputs2.id) || '',
            value2:
              Commons.EncryptAES(
                `User_Info/${inputs2.id}/Health/${imageFile.healthImage.name}`
              ) || '',
          },
        ]
      ).then((result) => {
        let data = result.data;

        if (data.length > 0) {
          if (data[0].type === 'Ok') {
            setInputs2({
              ...inputs2,
              healthImage: `User_Info/${inputs2.id}/Health/${imageFile.healthImage.name}`,
            });

            setSnackbar({
              ...snackbar,
              open: true,
              message:
                lanInfo.length > 0
                  ? lanInfo.filter((f) => f.LAN_ID === 'ItHasBeenSaved')[0]
                      .LAN_NM
                  : '',
              type: Commons.TypeSuccess().toLowerCase(),
            });
          } else {
            throw new Error(data[0].message ? data[0].message : '');
          }
        }
      });
    } catch (e) {
      console.log('Error: ', e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: Commons.TypeError().toLowerCase(),
      });
    } finally {
      setLoading(false);
    }
  };

  // 서명 저장
  const SaveLogic4 = async (_item) => {
    setLoading(true);
    let formList = new FormData();

    try {
      if (_item.size) {
        formList.append('value1', Commons.EncryptAES(userInfo.userid));
        formList.append(
          'value2',
          Commons.EncryptAES(`User_Info/${inputs2.id}/Sign`)
        );
        formList.append('value3', _item);

        await Commons.Axios(
          'file',
          Global.base.useUrl + Global.urls.Execute.ftpRequest,
          null,
          formList
        ).then((result) => {
          let data = result.data;
        });
      }

      await Commons.Axios(
        'post1',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_MyPage_U4',
            value1: Commons.EncryptAES(inputs2.id) || '',
            value2:
              Commons.EncryptAES(
                `User_Info/${inputs2.id}/Sign/${_item.name}`
              ) || '',
          },
        ]
      ).then((result) => {
        let data = result.data;

        if (data.length > 0) {
          if (data[0].type === 'Ok') {
            setInputs2({
              ...inputs2,
              sign: `User_Info/${inputs2.id}/Sign/${_item.name}`,
            });

            SearchLogic2(`User_Info/${inputs2.id}/Sign/${_item.name}`, 'sign');

            setSnackbar({
              ...snackbar,
              open: true,
              message:
                lanInfo.length > 0
                  ? lanInfo.filter((f) => f.LAN_ID === 'ItHasBeenSaved')[0]
                      .LAN_NM
                  : '',
              type: Commons.TypeSuccess().toLowerCase(),
            });
          } else {
            throw new Error(data[0].message ? data[0].message : '');
          }
        }
      });
    } catch (e) {
      console.log('Error: ', e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: Commons.TypeError().toLowerCase(),
      });
    } finally {
      setLoading(false);
    }
  };

  // 직인 저장
  const SaveLogic5 = async () => {
    setLoading(true);

    let formList = new FormData();

    try {
      if (!imageFile.journeyImage) {
        setSnackbar({
          ...snackbar,
          open: true,
          message:
            lanInfo.length === 0
              ? ''
              : lanInfo.find(
                  (f) => f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'NoImages'
                ).LAN_NM,
          type: Commons.TypeWarning().toLowerCase(), // 사진이 없습니다.
        });
        return false;
      }

      if (imageFile.journeyImage.size) {
        formList.append('value1', Commons.EncryptAES(userInfo.userid));
        formList.append(
          'value2',
          Commons.EncryptAES(`User_Info/${inputs2.id}/Journeyman`)
        );
        formList.append('value3', imageFile.journeyImage);

        await Commons.Axios(
          'file',
          Global.base.useUrl + Global.urls.Execute.ftpRequest,
          null,
          formList
        ).then((result) => {
          let data = result.data;
        });
      }

      await Commons.Axios(
        'post1',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_MyPage_U5',
            _userid: Commons.EncryptAES(inputs2.id) || '',
            _authCd: Commons.EncryptAES(userInfo.authCd) || '',
            _journeyman:
              Commons.EncryptAES(
                `User_Info/${inputs2.id}/Journeyman/${imageFile.journeyImage.name}`
              ) || '',
          },
        ]
      ).then((result) => {
        let data = result.data;

        if (data.length > 0) {
          if (data[0].type === 'Ok') {
            // // custInfo journeyman 업데이트
            // IndexedDb.UpdateTable("CustInfo", custData[0].CUST_CD, {
            //   ...custData[0],
            //   JOURNEYMAN: imageFile.profileImage
            //     ? `User_Info/${inputs2.id}/Journeyman/${imageFile.journeyImage.name}`
            //     : "",
            // });
            // // userInfo journeyman 업데이트
            // IndexedDb.UpdateTable("UserInfo", Commons.EncryptAES(inputs2.id), {
            //   ...userData,
            //   journeyman: imageFile.profileImage
            //     ? `User_Info/${inputs2.id}/Journeyman/${imageFile.journeyImage.name}`
            //     : "",
            // });

            setInputs2({
              ...inputs2,
              journeyman: `User_Info/${inputs2.id}/Journeyman/${imageFile.journeyImage.name}`,
            });

            setSnackbar({
              ...snackbar,
              open: true,
              message:
                lanInfo.length > 0
                  ? lanInfo.filter((f) => f.LAN_ID === 'ItHasBeenSaved')[0]
                      .LAN_NM
                  : '',
              type: Commons.TypeSuccess().toLowerCase(),
            });
          } else {
            throw new Error(data[0].message ? data[0].message : '');
          }
        }
      });
    } catch (e) {
      console.log('Error: ', e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: Commons.TypeError().toLowerCase(),
      });
    } finally {
      setLoading(false);
    }
  };
  //#endregion

  //#region 삭제
  // 회원 탈퇴
  const DeleteLogic1 = async (_item) => {
    setLoading(true);

    try {
      await Commons.Axios(
        'post1',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_MyPage_D1',
            value1: Commons.EncryptAES(inputs2.id) || '',
          },
        ]
      ).then(async (result) => {
        let data = result.data;

        if (data.length > 0) {
          if (data[0].TYPE === 'Ok') {
            window.localStorage.setItem(
              'auth',
              JSON.stringify({
                auth: false,
              })
            );

            navigate('/');
          } else {
            throw new Error(data[0].message ? data[0].message : '');
          }
        }
      });
    } catch (e) {
      console.log('Error: ', e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: Commons.TypeError().toLowerCase(),
      });
    } finally {
      setLoading(false);
    }
  };

  // 프로필 이미지 삭제
  const DeleteLogic2 = async () => {
    setLoading(true);

    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_MyPage_D2',
            value1: Commons.EncryptAES(userInfo.userid),
          },
        ]
      ).then((result) => {
        let data = result.data;

        if (data[0].TYPE === 'Ok') {
          setImageFile({
            ...imageFile,
            profileFiles: '', //파일 String
            profileImage: '', // 파일 정보
            profileFileName: '', //파일이름
          });
        }
      });
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };
  //#endregion
  //#region 나머지 함수
  const checkCapsLock = (e) => {
    let capsLock = e.getModifierState('CapsLock');
    setCapsLockFlag(capsLock);
  };
  //#endregion

  return (
    <div className="wrap">
      {Commons.IsMobile() ? (
        <MyPage_Mobile
          confirm={confirm}
          setConfirm={setConfirm}
          userInfo={userInfo}
          lanInfo={lanInfo}
          codeList={codeList}
          mobileModalToggle={mobileModalToggle}
          setMobileModalToggle={setMobileModalToggle}
          mobileModalToggle2={mobileModalToggle2}
          setMobileModalToggle2={setMobileModalToggle2}
          imageDialog={imageDialog}
          setImageDialog={setImageDialog}
          signDialog={signDialog}
          setSignDialog={setSignDialog}
          signCreateDialog={signCreateDialog}
          setSignCreateDialog={setSignCreateDialog}
          workSignature={workSignature}
          setWorkSignature={setWorkSignature}
          viewState={viewState}
          setViewState={setViewState}
          careerPeriodList={careerPeriodList}
          setCareerPeriodList={setCareerPeriodList}
          certificationInputs={certificationInputs}
          setCertificationInputs={setCertificationInputs}
          inputs={inputs}
          setInputs={setInputs}
          inputs2={inputs2}
          imageFile={imageFile}
          setImageFile={setImageFile}
          modalToggle4={modalToggle4}
          setModalToggle4={setModalToggle4}
          modalToggle5={modalToggle5}
          setModalToggle5={setModalToggle5}
          modalToggle6={modalToggle6}
          setModalToggle6={setModalToggle6}
          idDelete={idDelete}
          setIdDelete={setIdDelete}
          bloodList={bloodList}
          setBloodList={setBloodList}
          nationList={nationList}
          setNationList={setNationList}
          snackbar={snackbar}
          setSnackbar={setSnackbar}
          capsLockFlag={capsLockFlag}
          checkCapsLock={checkCapsLock}
          setCapsLockFlag={setCapsLockFlag}
          // 함수
          SearchLogic1={SearchLogic1}
          SearchLogic2={SearchLogic2}
          setInputs2={setInputs2}
          SaveLogic1={SaveLogic1}
          SaveLogic2={SaveLogic2}
          SaveLogic3={SaveLogic3}
          SaveLogic4={SaveLogic4}
          SaveLogic5={SaveLogic5}
          DeleteLogic1={DeleteLogic1}
          DeleteLogic2={DeleteLogic2}
        />
      ) : (
        <MyPage
          confirm={confirm}
          setConfirm={setConfirm}
          userInfo={userInfo}
          lanInfo={lanInfo}
          codeList={codeList}
          modalToggle={modalToggle}
          setModalToggle={setModalToggle}
          modalToggle2={modalToggle2}
          setModalToggle2={setModalToggle2}
          modalToggle3={modalToggle3}
          setModalToggle3={setModalToggle3}
          modalToggle4={modalToggle4}
          setModalToggle4={setModalToggle4}
          modalToggle5={modalToggle5}
          setModalToggle5={setModalToggle5}
          modalToggle6={modalToggle6}
          setModalToggle6={setModalToggle6}
          workSignature={workSignature}
          setWorkSignature={setWorkSignature}
          careerPeriodList={careerPeriodList}
          setCareerPeriodList={setCareerPeriodList}
          certificationInputs={certificationInputs}
          setCertificationInputs={setCertificationInputs}
          inputs={inputs}
          setInputs={setInputs}
          inputs2={inputs2}
          imageFile={imageFile}
          setImageFile={setImageFile}
          idDelete={idDelete}
          setIdDelete={setIdDelete}
          bloodList={bloodList}
          setBloodList={setBloodList}
          nationList={nationList}
          setNationList={setNationList}
          capsLockFlag={capsLockFlag}
          snackbar={snackbar}
          setSnackbar={setSnackbar}
          checkCapsLock={checkCapsLock}
          setCapsLockFlag={setCapsLockFlag}
          // 함수
          SearchLogic1={SearchLogic1}
          SearchLogic2={SearchLogic2}
          setInputs2={setInputs2}
          SaveLogic1={SaveLogic1}
          SaveLogic2={SaveLogic2}
          SaveLogic3={SaveLogic3}
          SaveLogic4={SaveLogic4}
          SaveLogic5={SaveLogic5}
          DeleteLogic1={DeleteLogic1}
          DeleteLogic2={DeleteLogic2}
        />
      )}
      <Loading open={loading} />
      <Snackbar
        open={snackbar.open}
        message={snackbar.message}
        type={snackbar.type}
        onClose={() => {
          setSnackbar({
            ...snackbar,
            open: false,
          });
        }}
      />
    </div>
  );
}

export default MyPageFunction;
